import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";

const url = process.env.REACT_APP_API_BASE_URL;
const ndovuUrl = process.env.REACT_APP_API_REPORT_URL;

const initialState = {
  loading: false,
  loadingGrid: false,
  loadingBal: false,
  loadingReturnDate: false,
  loadingGenerateReport: false,
  coBranchCount: 0,
  coBranch: [],
  balances: "",
  MBs: "",

  leaveType: [],
  leaveBal: [],
  returnDate: null,
  leaveAppl: [],
  leaveApplCount: 0,
  pendingLeaveAppr: [],
  pendingLeaveApprCount: 0,
  leaveBals: [],
  shiftReq: [],
  shiftType: [],
  shiftReqCount: 0,
  approvers:[],
  approversCount:0,
  loadingTable: false,
};

export const fetchLeaveType = createAsyncThunk(
  "dropdwonSlice/fetchLeaveType",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchLeaveType.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLvBals = createAsyncThunk(
  "dropdwonSlice/fetchLvBals",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchLvBals.action?fpPyear_id=${data?.fpPyear_id}&ltId_id=${data?.ltId_id}`
      )
      .then((res) => res.data);
    return res;
  }
);
export const fetchReturnDate = createAsyncThunk(
  "dropdwonSlice/fetchReturnDate",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchReturnDate.action?startDate=${data?.startDate}&daysTaken=${data?.daysTaken}&dueDate=${data?.dueDate}
        `
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLeaveApp = createAsyncThunk(
  "dropdwonSlice/fetchLeaveApp",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchLeaveApp.action?limit=${data?.limit ?? null}&start=${
          data?.start ?? 0
        }&laApproved=${data?.laApproved ?? null}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchPendingLeaveApproval = createAsyncThunk(
  "dropdwonSlice/fetchPendingLeaveApproval",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchPendingLeaveApproval.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const getBalances = createAsyncThunk(
  "dropdwonSlice/getBalances",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/shift/getBalances.action`)
      .then((res) => res.data);
    return res;
  }
);

export const generateLeaveReport = createAsyncThunk(
  "dropdownSlice/generateLeaveReport",
  async (data) => {
    const { laId } = data;
    const queryString = new URLSearchParams({
      laId,
    }).toString();

    const res = await axiosInstance
      .get(`${url}/myReports/direct_reports_leaveform.action?${queryString}`, {
        responseType: "arraybuffer",
      })
      .then((res) => res.data);
    return res;
  }
);

export const generatePayslip = createAsyncThunk(
  "dropdownSlice/generatePayslip",
  async (data) => {
    const { year, month } = data;
    const queryString = new URLSearchParams({
      year,
      month,
    }).toString();

    const res = await axiosInstance
      .get(`${url}/myReports/viewSlip.action?${queryString}`, {
        responseType: "arraybuffer",
      })
      .then((res) => res.data);
    return res;
  }
);

export const generateP9 = createAsyncThunk(
  "dropdownSlice/generateP9",
  async (data) => {
    const { year } = data;
    const queryString = new URLSearchParams({
      year,
    }).toString();

    const res = await axiosInstance
      .get(`${url}/myReports/view_p9.action?${queryString}`, {
        responseType: "arraybuffer",
      })
      .then((res) => res.data);
    return res;
  }
);

export const resetPassword = createAsyncThunk(
  "dropdwonSlice/resetPassword",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/usr/updatePassword.action?oldUsrEncryptedPassword=${data.oldUsrEncryptedPassword}&newUsrEncryptedPassword=${data?.newUsrEncryptedPassword}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchLeaveBals = createAsyncThunk(
  "dropdwonSlice/fetchLeaveBals",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchLeaveTypeBals.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchShiftRequest = createAsyncThunk(
  "dropdwonSlice/fetchShiftRequest",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchShiftRequest.action?limit=${
          data?.limit ?? null
        }&start=${data?.start ?? 0}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const fetchShiftType = createAsyncThunk(
  "dropdwonSlice/fetchShiftType",
  async (data) => {
    const res = await axiosInstance
      .get(`http://102.217.125.134/NDOVUHR_BACKEND/shift/fetchShiftType.action`)
      .then((res) => res.data);
    return res;
  }
);
 
export const fetchApprovers = createAsyncThunk(
  "dropdwonSlice/fetchApprovers",
  async (data) => {
    const res = await axiosInstance
      .get(
        `${url}/self/fetchLeaveApprovers.action?laId=${data?.laId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const dropdownSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    clearDropObj: () => {
      return { ...initialState };
    },
    cleanLeaveBal: (state) => {
      state.leaveBal = initialState.leaveBal;
      state.returnDate = initialState.returnDate;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getBalances.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBalances.fulfilled, (state, action) => {
        state.loading = false;
        state.balances = action?.payload?.data?.Balance;
        state.MBs = action?.payload?.data?.MBs;
      })
      .addCase(getBalances.rejected, (state, action) => {
        state.loading = false;
        state.balances = "";
        state.MBs = "";
      })

      .addCase(fetchLeaveType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveType.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveType = action?.payload?.data?.result;
      })
      .addCase(fetchLeaveType.rejected, (state) => {
        state.loading = false;
        state.leaveType = [];
      })

      .addCase(fetchLvBals.pending, (state) => {
        state.loadingBal = true;
      })
      .addCase(fetchLvBals.fulfilled, (state, action) => {
        state.loadingBal = false;
        state.leaveBal = action?.payload?.data?.result;
      })
      .addCase(fetchLvBals.rejected, (state) => {
        state.loadingBal = false;
        state.leaveBal = [];
      })

      .addCase(fetchReturnDate.pending, (state) => {
        state.loadingReturnDate = true;
      })
      .addCase(fetchReturnDate.fulfilled, (state, action) => {
        state.loadingReturnDate = false;
        state.returnDate = action?.payload?.jsonData;
      })
      .addCase(fetchReturnDate.rejected, (state) => {
        state.loadingReturnDate = false;
        state.returnDate = null;
      })

      .addCase(fetchLeaveApp.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveApp.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveAppl = action?.payload?.data?.result;
        state.leaveApplCount = action?.payload?.data?.total;
      })
      .addCase(fetchLeaveApp.rejected, (state) => {
        state.loading = false;
        state.leaveAppl = [];
        state.leaveApplCount = 0;
      })

      .addCase(fetchPendingLeaveApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPendingLeaveApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingLeaveAppr = action?.payload?.data?.result;
        state.pendingLeaveApprCount = action?.payload?.data?.total;
      })
      .addCase(fetchPendingLeaveApproval.rejected, (state) => {
        state.loading = false;
        state.pendingLeaveAppr = [];
        state.pendingLeaveApprCount = 0;
      })

      .addCase(generateLeaveReport.pending, (state) => {
        state.loadingGenerateReport = true;
      })
      .addCase(generateLeaveReport.fulfilled, (state, action) => {
        state.loadingGenerateReport = false;
      })
      .addCase(generateLeaveReport.rejected, (state) => {
        state.loadingGenerateReport = false;
      })

      .addCase(generatePayslip.pending, (state) => {
        state.loadingGenerateReport = true;
      })
      .addCase(generatePayslip.fulfilled, (state, action) => {
        state.loadingGenerateReport = false;
      })
      .addCase(generatePayslip.rejected, (state) => {
        state.loadingGenerateReport = false;
      })

      .addCase(generateP9.pending, (state) => {
        state.loadingGenerateReport = true;
      })
      .addCase(generateP9.fulfilled, (state, action) => {
        state.loadingGenerateReport = false;
      })
      .addCase(generateP9.rejected, (state) => {
        state.loadingGenerateReport = false;
      })

      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state) => {
        state.loading = false;
      })

      .addCase(fetchLeaveBals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLeaveBals.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveBals = action?.payload?.data?.result;
      })
      .addCase(fetchLeaveBals.rejected, (state) => {
        state.loading = false;
        state.leaveBals = [];
      })

      .addCase(fetchShiftRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShiftRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftReq = action?.payload?.data?.result;
        state.shiftReqCount = action?.payload?.data?.total;
      })
      .addCase(fetchShiftRequest.rejected, (state) => {
        state.loading = false;
        state.shiftReq = [];
        state.shiftReqCount = 0;
      })

      .addCase(fetchShiftType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShiftType.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftType = action?.payload?.data?.result;
      })
      .addCase(fetchShiftType.rejected, (state, action) => {
        state.loading = false;
        state.shiftType = [];
      }) 

      .addCase(fetchApprovers.pending, (state) => {
        state.loadingTable = true;
      })
      .addCase(fetchApprovers.fulfilled, (state, action) => {
        state.loadingTable = false;
        state.approvers = action?.payload?.data?.result;
        state.approversCount = action?.payload?.data?.total;
      })
      .addCase(fetchApprovers.rejected, (state, action) => {
        state.loadingTable = false;
        state.approvers = [];
        state.approversCount = 0;
      })
 
  },
});

export default dropdownSlice.reducer;
export const {
  handleSideMenuCollapse,
  setResellerId,
  cleanResellerId,
  setLegendClickStatus,
  cleanLegendClickStatus,
  clearDropObj,
  cleanLeaveBal,
} = dropdownSlice.actions;
